import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Button } from 'react-bootstrap';
import { isObject as _isObject } from 'lodash';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import Loader from 'components/layout/Loader';

import FormInput from 'components/forms/FormInput';
import FormFile from 'components/forms/FormFile';
import FormTextarea from 'components/forms/FormTextarea';

class PageSeo extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['seo'];

    this.state = {
      showFileUpload: false,
      mouseOver: false,
    };
  }

  uploadSeoImage = images => {
    if (_isObject(images) && images.length === 1) {
      const fd = new FormData();
      fd.append('seoImage', images[0]);

      this.setState({ uploadingImage: images[0], showFileUpload: false });
      this.props.uploadSeoImage(this.props.entity.getId(), fd);
    }
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatus,
      doNotify,
    } = this.props;

    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      // image has been uploaded, update the entity
      const value = this.props.entity.createValue('seoImage', [], formStatus.response);
      const newEntity = { ...this.props.entity.updateValue('seoImage', value) };
      this.props.changeEntity(newEntity);

      doNotify(1, messages.file_uploaded);
    }
  };

  mouseEnter = () => {
    this.setState({ mouseOver: true });
  };

  mouseLeave = () => {
    this.setState({ mouseOver: false });
  };

  resetImage = () => {
    const newEntity = { ...this.props.entity.updateValue('seoImage', {}) };
    this.props.changeEntity(newEntity);
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
      formStatus,
    } = this.props;
    const { mouseOver } = this.state;

    let background = {};
    if (entity.getSeoImage().getId()) {
      const thumbnail = getThumbFileFromEntity(entity.getSeoImage());
      if (thumbnail) {
        background = {
          ...background,
          backgroundImage: 'url(' + thumbnail.getWebLink() + ')',
          backgroundSize: 'cover',
        };
      }
    }

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.seo}</p>
                  <div class="form-group-attached">
                    <FormInput
                      label={messages.page_title}
                      name="title"
                      value={entity.getSeo().getTitle()}
                      meta={entity.getSeo().getTitleMetaInformation()}
                      validation={entity.getSeo().getTitleValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormTextarea
                      label={messages.description}
                      name="description"
                      value={entity.getSeo().getDescription()}
                      meta={entity.getSeo().getDescriptionMetaInformation()}
                      validation={entity.getSeo().getDescriptionValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.keywords}
                      name="keywords"
                      value={entity.getSeo().getKeywords()}
                      meta={entity.getSeo().getKeywordsMetaInformation()}
                      validation={entity.getSeo().getKeywordsValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>

                  {!inModal ? (
                    <div>
                      {entity.getSeoImage().getId() && !this.state.showFileUpload && !formStatus.pending ? (
                        <div
                          class="form-group form-group-default"
                          onMouseEnter={this.mouseEnter}
                          onMouseLeave={this.mouseLeave}
                        >
                          <label>{messages.image}</label>
                          <div style={{ position: 'relative', width: '100%' }}>
                            {mouseOver && entity.getSeoImage().getId() ? (
                              <div style={{ position: 'absolute', top: '10px', right: '10px' }}>
                                <Button class="text-danger pull-right" bsSize="xsmall" onClick={this.resetImage}>
                                  <i class="fa fa-times" />
                                </Button>
                              </div>
                            ) : null}
                            <div style={{ position: 'absolute', width: '100%', top: '50%' }} class="text-center">
                              <div style={{ transform: 'translateY(-50%)' }}>
                                <Button
                                  onClick={() => this.setState({ showFileUpload: true })}
                                  class="btn-rounded"
                                  bsSize="sm"
                                >
                                  <i class="fa fa-cog m-r-10" />
                                  {messages.change_image}
                                </Button>
                              </div>
                            </div>
                            <div style={{ width: '100%', paddingBottom: '56.25%', ...background }} />
                          </div>
                        </div>
                      ) : (
                        <div class="form-group-attached">
                          {formStatus.pending ? (
                            <div class="form-group form-group-default">
                              <label>{messages.image}</label>
                              <Loader />
                            </div>
                          ) : (
                            <div class="form-group-attached">
                              <FormFile
                                label={messages.image}
                                name="seoImage"
                                onChange={(name, files) => this.uploadSeoImage(files)}
                              />
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
        ) : null}
      </div>
    );
  }
}
PageSeo.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.pageSeoImage,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    uploadSeoImage: (pageId, args) => {
      formStatusDispatchHelper('pageSeoImage', '/api/pages/' + pageId + '/seoimage.json', args, 'post', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PageSeo)
);
